module.exports = __webpack_public_path__ + "National2Web-Extralight.eot?a5472931bab6d0bb0d2718ba8bb90dc8";